<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div id="templatePane">
    <div class="hero-section shade-40">
      <div class="hero-section-text row column">
        <h1>Okay, what number would be best to contact you on?</h1>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <section id="mainContent" class="content row column" v-if="!loading" key="loading-finished">
        <form v-on:submit.prevent="submit" id="fb-phone-mfa" novalidate data-abide>
          <h2>What's your preferred phone number?</h2>
          <p>This is the number for a phone that you'll have to hand when you sign in to Workplace - it can be a work or
            personal phone.</p>
          <p>The best option is to use your mobile phone as you're more likely to have it with you when you sign in, but
            if you'd prefer to use a landline we can call you on that.</p>
          <p>Please don't use your Skype number, as it can be insecure.</p>
          <div class="phone-container clearfix">
            <span class="float-left">
              <select v-model="countryCode" name="country-code" id="country-code" aria-label="Select country" required>
                <option v-for="country in countries" v-bind:key="country.code" :value="country.code"
                  :data-country-prefix="country.prefix">{{ country.name }}</option>
              </select>
              <span class="form-error" data-form-error-for="country-code">Please tell us the country your phone number is
                registered in</span>
            </span>
            <span class="float-left">
              <input v-model="authenticationPhone" aria-label="Your phone number" data-validator="phonenumber" type="text"
                id="phone-number" maxlength="15" required />
              <span class="form-error" data-form-error-for="phone-number">{{ numberNotValidMessage }}</span>
            </span>
          </div>
          <h2>Shall we call or text?</h2>
          <p>We recommend text as it's less intrusive for you and the people around you.</p>
          <div role="radiogroup" class="radio-inline" id="call-or-text-group">
            <div class="radio">
              <input v-model="authenticationMethod" class="radio-input" id="call-or-text-text" name="call-or-text"
                type="radio" value="text" />
              <label class="radio-label" for="call-or-text-text">
                Send me codes via text
              </label>
            </div>
            <div class="radio">
              <input v-model="authenticationMethod" class="radio-input" id="call-or-text-call" name="call-or-text"
                type="radio" value="call" />
              <label class="radio-label" for="call-or-text-call">
                Call me
              </label>
            </div>
          </div>
          <button class="button" :disabled="submitted" type="submit">Set my number</button>
        </form>
      </section>
      <section class="content" v-if="loading" key="still-loading">
        <img class="loading" src="/static/images/ajax-loader.gif">
      </section>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import api from '../../api'
import authentication from '../../authentication'
import countries from 'i18n-iso-countries'
import english from 'i18n-iso-countries/langs/en.json'
import { parsePhoneNumberFromString, isSupportedCountry, getCountryCallingCode } from 'libphonenumber-js'
import router from '../../router'

export default {
  name: 'EnterPhoneNumber',
  title: 'Workplace - Enter your phone number',
  data: function () {
    return {
      user: "",
      authenticationPhone: localStorage.authenticationPhone || "",
      countryCode: localStorage.countryCode || 'GB',
      authenticationMethod: localStorage.authenticationMethod || "text",
      loading: false,
      countries: [],
      submitted: false,
      numberNotValidMessage: "That doesn't look like a valid phone number"
    }
  },
  methods: {
    validatePhoneNumber: function (
      $el,      /* jQuery element to validate */
      required, /* is the element required according to the `[required]` attribute */
      parent    /* parent of the jQuery element `$el` */
    ) {
      console.log(`${this.authenticationPhone}, ${this.countryCode}`)
      let skypeNumberRegex = /^331(652|654|664)/
      let phoneNumber = parsePhoneNumberFromString(this.authenticationPhone, this.countryCode)
      if (phoneNumber) {
        if (phoneNumber.isValid() && !phoneNumber.nationalNumber.match(skypeNumberRegex)) {
          console.log("Looks valid...")
          return true
        }

        if (phoneNumber.nationalNumber.match(skypeNumberRegex)) {
          this.numberNotValidMessage = "That looks like a Skype number, which isn't allowed"
          console.log(`Skype number provided`)
        } else {
          this.numberNotValidMessage = "That doesn't look like a valid phone number"
          console.log(`invalid phone number for region ${this.countryCode}`)
        }
        return false
      }
      console.log("no phone number provided")
      return false
    },
    formatPhoneNumber: function () {
      let phoneNumber = parsePhoneNumberFromString(this.authenticationPhone, this.countryCode)
      if (phoneNumber) {
        if (phoneNumber.isValid()) {
          return `+${phoneNumber.countryCallingCode} ${phoneNumber.nationalNumber}`
        }
      }
      return null
    },
    submit: function (event) {
      // Check that we're not double clicking
      if (this.submitted) {
        return;
      }
      this.submitted = true;
      // Revalidate form
      const formEl = document.getElementById('fb-phone-mfa')
      $(formEl).foundation('validateForm', $('form'))
      if ($(formEl).find('.form-error.is-visible').length || $(formEl).find('.is-invalid-label').length) {
        // Re-enable the button
        this.submitted = false;
        return false;
      }

      const phoneNumber = this.formatPhoneNumber();
      console.log(`Submitting number ${phoneNumber}`)
      this.loading = true;
      event.preventDefault();

      if (!authentication.getCachedToken()) {
        localStorage.authenticationPhone = this.authenticationPhone;
        localStorage.authenticationMethod = this.authenticationMethod;
        localStorage.countryCode = this.countryCode;
        localStorage.enterPhoneNumber = true;
        authentication.acquireTokenRedirect()
      } else {
        authentication.getCachedToken().then(response => {
          var token = response.rawIdToken;
          api.submitAuthentication(phoneNumber, this.authenticationMethod, token, true)
            .then(response => {
              router.push({ path: "done", query: { claimLink: response.data.claimLink, workplaceTenant: response.data.workplaceTenant, authenticationPhone: phoneNumber, authenticationMethod: this.authenticationMethod, completionState: response.data.completionState } });
            })
            .catch(error => {
              router.push(this.getErrorRedirect(error))
            });
        });
      }
    },
    guessCountryCode: function () {
      // Guess based on IP, or fallback
      this.countryCode = 'GB'
      axios.get('http://ip-api.com/json')
        .then(response => {
          this.countryCode = response.data.countryCode;
          console.log(`Guessed ${this.countryCode}`)
        })
        .catch(error => {
          console.log("Can't even guess user's country - leaving it at GB")
        });
    },
    getKeyByValue: function (object, value) {
      return Object.keys(object).find(key => object[key] === value);
    },
    sortValuesAlphabetically: function (a, b) {
      const aValue = a.toLowerCase()
      const bValue = b.toLowerCase()
      if (aValue < bValue) {
        return -1;
      }
      if (aValue > bValue) {
        return 1;
      }
      return 0;
    },
    populateCountrySelector: function () {
      // Register the fact we want the country names in English.
      countries.registerLocale(english);
      const listOfCountries = Object(countries.getNames('en'))
      // Sort countries alphabetically
      Object.values(listOfCountries).sort(this.sortValuesAlphabetically).forEach((value) => {
        const key = this.getKeyByValue(listOfCountries, value)
        if (isSupportedCountry(key)) {
          this.countries.push({ name: `${listOfCountries[key]} (+${getCountryCallingCode(key)})`, code: key, prefix: `+${getCountryCallingCode(key)}` });
        }
        else {
          console.log('${listOfCountries[key]} dialing code is not found')
        }
      });
    },
    setInitialCountry: function () {
      // Firstly, have we been passed this from the profile?
      if (this.$route.query.countryCode) {
        this.countryCode = this.$route.query.countryCode;
        console.log('Setting initial country to ' + this.countryCode)
      } else {
        this.guessCountryCode();
      }
    },
    removePortalLocalStorage: function () {
      localStorage.removeItem('authenticationMethod');
      localStorage.removeItem('authenticationPhone');
      localStorage.removeItem('countryCode');
      localStorage.removeItem('enterPhoneNumber');
    }
  },

  mounted() {
    // Set up abide custom validator
    Foundation.Abide.defaults.validators['phonenumber'] = this.validatePhoneNumber;
    // eslint-disable-next-line
    this.abide = new Foundation.Abide($('[data-abide]'))
    this.user = authentication.getUserProfile();
    // Figure the user's country
    this.setInitialCountry();
    // Build the list of countries selector
    this.populateCountrySelector();
    this.removePortalLocalStorage();
  },
  destroyed() {
    // eslint-disable-next-line
    if (typeof this.abide !== 'undefined') {
      this.abide.destroy()
    }
  }
}
</script>

<style scoped>
.loading {
  margin-left: auto;
  margin-right: auto;
  display: block;
  margin-top: 30px;
  margin-bottom: 50px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .2s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.content {
  min-height: 100px;
}</style>